// extracted by mini-css-extract-plugin
module.exports = {"mainBlockTitle":"_1VkAhmgo","employerContent":"KEq5Hc60","statusContent":"L2Sdd0Qi","dateContent":"_1ZuizqpZ","companyHeader":"oXiurREu","otherHeader":"_39wheS7C","blockTitle":"_35lJKohJ","firstBlock":"_2F35u5LV"};
    if(module.hot) {
      // 1754515042375
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  